import { useEffect, useState } from 'react'
import Papa                    from 'papaparse'
import * as iconv              from 'iconv-lite'

export const useCsvDataLoader = (csvUrl, encoding) => {
  const [csvLoading, setCsvLoading] = useState(false)
  const [error,      setError]      = useState(null)
  const [columns,    setColumns]    = useState([])
  const [rows,       setRows]       = useState([])

  useEffect(() => {
    let isCancelled = false

    const loadData = async () => {
      setCsvLoading(true)
      setError(null)

      try {
        const response    = await fetch(csvUrl)
        const arrayBuffer = await response.arrayBuffer()
        const buffer      = Buffer.from(arrayBuffer)
        const text        = iconv.decode(buffer, encoding || 'utf-8')

        if (!isCancelled) {
          const { data, meta } = Papa.parse(text, {
            delimiter:      '',
            header:         true,
            skipEmptyLines: true,
            trimHeaders:    true,
          })

          const headers = meta.fields || [];
          setColumns(headers)
          setRows(data)
        }
      } catch (err) {
        if (!isCancelled) {
          setError(err.message)
        }
      } finally {
        if (!isCancelled) setCsvLoading(false)
      }
    }

    loadData()
    return () => { isCancelled = true }
  }, [csvUrl, encoding])

  return { csvLoading, error, columns, rows }
}
